import { render, staticRenderFns } from "./EmergencyContactFirstAidInfoPage.vue?vue&type=template&id=60940110&scoped=true"
import script from "./EmergencyContactFirstAidInfoPage.vue.js?vue&type=script&lang=js&external"
export * from "./EmergencyContactFirstAidInfoPage.vue.js?vue&type=script&lang=js&external"
import style0 from "./EmergencyContactFirstAidInfoPage.vue?vue&type=style&index=0&id=60940110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60940110",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
